import { HttpService } from '@src/api/common/HttpService';
import { UrlService } from '@src/api/common/UrlService';
import { CTE_API_URL } from '@src/constants/BaseUrls';

type ThemeType = {
  id: number;
};

export const ThemeService = () => {
  const { HttpGet, HttpDelete, HttpPost } = HttpService();

  const GetThemeAll = async (query: string) => {
    const url = `${CTE_API_URL}/api/v1/theme${query}`;
    const response = await HttpGet(url);
    return response;
  };

  const GetThemeById = async (body: ThemeType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CTE_API_URL}/api/v1/theme/detail${suffix}`;
    const response = await HttpGet(url);
    return response;
  };

  const CreateOrUpdateTheme = async (body: any) => {
    const url = `${CTE_API_URL}/api/v1/theme/detail`;
    const response = await HttpPost(url, body);
    return response;
  };

  const LogicDeleteThemeById = async (body: ThemeType) => {
    const suffix = UrlService.BuildQuery(body);
    const url = `${CTE_API_URL}/api/v1/theme/detail${suffix}`;
    const response = await HttpDelete(url);
    return response;
  };

  return {
    GetThemeAll,
    GetThemeById,
    CreateOrUpdateTheme,
    LogicDeleteThemeById,
  };
};